import * as THREE from 'three';

export function foreachMesh(obj, func) {
  if (obj instanceof THREE.Mesh) {
    func(obj);
  }
  obj.children.forEach(child => foreachMesh(child, func));
}

export function disposeObject(obj) {
  if (obj instanceof THREE.Mesh || obj instanceof THREE.Line) {
    if (obj.geometry) {
      obj.geometry.dispose();
    }

    if (obj.material) {
      if (Array.isArray(obj.material)) {
        for (var i = 0; i < obj.material.length; i++) {
          obj.material[i].dispose();
        }
      } else {
        obj.material.dispose();
      }
    }
  }

  for (var i = 0; i < obj.children.length; i++) {
    disposeObject(obj.children[i]);
  }
}
